import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { MdSwitch, MdDialog, MdTabs, MdButton } from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import VueRouter from 'vue-router'
import store from './store'
import Checkout from './pages/Checkout.vue'
import CartAddress from './pages/CartAddress.vue'
import ConfirmOrder from './pages/ConfirmOrder.vue'
import Cart from './pages/Cart.vue'
import FoodMenu from './pages/FoodMenu.vue'
import SelfService from './pages/SelfService.vue'
import SelfServiceCheckout from './pages/SelfServiceCheckout.vue'
import Success from './pages/Success.vue'
import Failure from './pages/Failure.vue'
import OrderStatusSelfService from './pages/OrderStatusSelfService.vue'
import DeliveryForm from './pages/DeliveryForm.vue'
import App from './App.vue'
// import './plugins/vuetify.js'

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueRouter)

Vue.use(MdSwitch)
Vue.use(MdDialog)
Vue.use(MdTabs)
// Vue.use(MdTab)
Vue.use(MdButton)

const routes = [
  { path: '/', component: Cart },
  { path: '/Cart/*', component: Cart },
  { path: '/Checkout', component: Checkout },
  { path: '/CartAddress', component: CartAddress },
  { path: '/ConfirmOrder', component: ConfirmOrder },
  { path: '/SelfService', component: SelfService },
  { path: '/SelfServiceCheckout', component: SelfServiceCheckout },
  { path: '/Success', component: Success },
  { path: '/Failure', component: Failure },
  { path: '/OrderStatusSelfService', component: OrderStatusSelfService },
  { path: '/DeliveryForm', component: DeliveryForm },
  { path: '/FoodMenu', component: FoodMenu },
]

const router = new VueRouter({
  routes // short for `routes: routes`,
})

// console.log(process.env.PEPE);
// console.log(process.env);


new Vue({
  el: '#app',
  router: router,
  store: store,
  render: h => h(App)//,
//   watch: {
//     '$route.params.search': {
//     handler: function(search) {
//        if(this.$route.fullPath.includes('/SelfService') {

//        }
//     },
//     deep: true,
//     immediate: true
//   }
// }
})



// WEBPACK FOOTER //
// ./src/main.js